import NoRequestedDataFoundModal from './noRequestedDataModal'
import WebFlowSelectorModal from './webFlowSelectorModal'

const config = {
  NoRequestedDataFoundModal: NoRequestedDataFoundModal,
  WebFlowSelectorModal: WebFlowSelectorModal,
}

const defaultOptions = { backdropOpacity: 0.6, disableFlingGesture: true }
export interface ModalStackParams {
  WebFlowSelectorModal: any
  NoRequestedDataFoundModal: {
    message: string
  }
}

const modalConfig = {
  config,
  defaultOptions,
}
export default modalConfig
